import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import AttendanceToggle from "../AttendanceToggle";

const AttendanceOverlay = ({
  show,
  onClose,
  onLogout,
  onSuccess,
  zIndex="1000",
  message = "Please mark your attendance.",
}) => {
  if (!show) return null;

  return (
    <div className="geolocation-overlay" style={{zIndex:zIndex}}>
      <style>
        {`
          .geolocation-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.7);
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .geolocation-overlay-content {
            background: var(--white);
            border-radius: var(--rounded-12);
            padding: var(--size-24);
            max-width: 32rem;
            width: 100%;
            text-align: center;
            box-shadow: var(--shadow-2);
            position: relative;
          }

          [data-theme='dark'] .geolocation-overlay-content {
            background: var(--dark-1);
          }

          .geolocation-overlay-content .close-button {
            position: absolute;
            top: 10px;
            right: 10px;
            background: none;
            border: none;
            font-size: 1.5rem;
            cursor: pointer;
            color: var(--text-primary-light);
          }

          [data-theme='dark'] .geolocation-overlay-content .close-button {
            color: var(--text-primary-light);
          }

          .geolocation-overlay-content h3 {
            font-size: var(--font-xl);
            font-weight: 600;
            color: var(--text-primary-light);
            margin-bottom: var(--size-16);
          }

          [data-theme='dark'] .geolocation-overlay-content h3 {
            color: var(--text-primary-light);
          }

          .geolocation-overlay-content p {
            font-size: var(--font-md);
            color: var(--text-secondary-light);
          }

          [data-theme='dark'] .geolocation-overlay-content p {
            color: var(--text-secondary-light);
          }

          .geolocation-overlay-content .retry-button,
          .geolocation-overlay-content .logout-button {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: var(--size-8);
            padding: var(--size-12) var(--size-24);
            border: none;
            border-radius: var(--rounded-8);
            font-size: var(--font-md);
            font-weight: 500;
            cursor: pointer;
            transition: background 0.3s ease;
          }

          .geolocation-overlay-content .retry-button {
            background: var(--primary-600);
            color: var(--neutral-50);
          }

          .geolocation-overlay-content .retry-button:hover {
            background: var(--primary-700);
          }

          [data-theme='dark'] .geolocation-overlay-content .retry-button {
            color: var(--neutral-50);
          }

          .geolocation-overlay-content .logout-button {
            background: var(--danger-600);
            color: var(--neutral-50);
          }

          .geolocation-overlay-content .logout-button:hover {
            background: var(--danger-700);
          }

          [data-theme='dark'] .geolocation-overlay-content .logout-button {
            color: var(--neutral-50);
          }

          .geolocation-overlay-content .button-group {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            margin-top: 16px;
          }
        `}
      </style>
      <div className="geolocation-overlay-content">
        {/* <button className="close-button" onClick={onClose} title="Close">
          <Icon icon="mdi:close" />
        </button> */}
        <p className="fw-bold">Attendance Required</p>
        <p>{message}</p>
        <div className="d-flex justify-content-center mb-3">
          <AttendanceToggle messageShow={{ check: true }} onSuccess={onSuccess} />
        </div>
        <div className="button-group">
          <button className="retry-button" onClick={onClose}>
            Back
          </button>
          <button className="logout-button" onClick={onLogout}>
            <Icon icon="mdi:logout" />
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default AttendanceOverlay;